import * as React from 'react';
import { forEach, flow } from 'lodash';
import appConfig from '../../../../config/main';
import Helmet from 'react-helmet';
import Header from './scenes/Header';
import Footer from './scenes/Footer';
import { withRouter } from 'react-router';
import { IChannel } from '../../data/api/models';
import { isUndefined } from 'util';

interface IShellProps {
  steps: object;
  channel: IChannel;
  pageTitles: object;
  location: Location;
}

interface IShellState {
  hasUserAcceptCookies: boolean;
  hideContainer: boolean;
  hiddenClickCount: number;
  hiddenClickThreshold: number;
}

class Shell extends React.Component<IShellProps, IShellState> {
  public state = {
    hasUserAcceptCookies: false,
    hideContainer: false,
    hiddenClickCount: 0,
    hiddenClickThreshold: 40,
  };

  public constructor(props) {
    super(props);

    if (process.env.BROWSER) {
      const accepted: boolean = window.localStorage.getItem('eu-cookie-accepted') === 'true';

      this.state = {
        hasUserAcceptCookies: accepted,
        hideContainer: accepted,
        hiddenClickCount: 0,
        hiddenClickThreshold: 40,
      };
    }
  }

  private handleSecretClick = () => {
    this.setState({
      hiddenClickCount: this.state.hiddenClickCount + 1,
    });

    if (this.state.hiddenClickCount > this.state.hiddenClickThreshold) {
      this.setState({
        hiddenClickCount: 0,
      });
    }
  }

  public render() {
    const { children, steps, channel, location, pageTitles } = this.props;
    const { hiddenClickCount, hiddenClickThreshold } = this.state;

    let subTitle = '';

    forEach(steps, (step) => {
      if (step.route === location.pathname) {
        subTitle = step.title;
      }
    });

    if (! subTitle && ! isUndefined(pageTitles[location.pathname])) {
      subTitle = pageTitles[location.pathname];
    }

    const brandTemplate =  {
      titleTemplate: `${channel.baseName}: ${subTitle}`,
    };

    return (
      <div className={hiddenClickCount === hiddenClickThreshold ? 'secret-flip' : ''}>
        <Helmet {...appConfig.app.head} {...brandTemplate} />
        <Header steps={steps} channel={channel} location={location} />
        {children}
        <Footer channel={channel} />
        <div className="secret-btn" onClick={this.handleSecretClick}/>
      </div>
    );
  }
}

export default flow([
  withRouter,
])(Shell);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/index.tsx